import React from 'react'
import Videos from '../Videos/Videos'

export default function Home() {
    return (
        <Videos />
    )
}
